<p-card styleClass="flex w-full h-full p-4">
  <ng-template pTemplate="header">
    <div class="card-header">
      <h2>My Potential Trips</h2>
    </div>
  </ng-template>
  <div class="nano-content h-full">
    <div class="row">
      <div class="col-md-12">
        <div class="loading" *ngIf="loading()">
          <p-progressSpinner></p-progressSpinner>
        </div>

        <div class="error" *ngIf="error()">
          <p-message severity="error" [text]="error()"></p-message>
        </div>

        <div class="potential-trips-list">
          <ng-container *ngIf="potentialTrips().length; else noTrips">
            <app-potential-trips
              *ngIf="!loading() && !error()"
              [pTrips]="potentialTrips()"
              [contacts]="contacts()"
              [customers]="customers()"
              [tripDetails]="tripDetails()"
              [miniMode]="true"
              [showCustomerName]="true"
              [showHeader]="false"
              [maxHeight]="300"
            ></app-potential-trips>
          </ng-container>
          <ng-template #noTrips>
            <div class="flex justify-center items-center p-4 text-gray-500">
              <p>No potential trips found.</p>
            </div>
          </ng-template>
        </div>
      </div>
    </div>
  </div>
</p-card> 